import VueTheMask from "vue-the-mask";
import {
  can,
  hasPermissionConselho,
  array_prepend,
  routeFrom,
  routeBack,
  routeToCache,
} from "@/helpers/functions";

export default {
  install(Vue) {
    Vue.use(VueTheMask);
    Vue.prototype.$can = can;
    Vue.prototype.$hasPermissionConselho = hasPermissionConselho;
    Vue.prototype.$array_prepend = array_prepend;
    Vue.prototype.$routeFrom = routeFrom;
    Vue.prototype.$routeBack = routeBack;
    Vue.prototype.$routeToCache = routeToCache;
  },
};
